import React from 'react';
import dayjs from 'dayjs';
import type { ColumnsType } from 'antd/es/table';
import { IAssessmentHistory } from 'entities/PatientMetrics/PatientMetrics.models';

export const renderAssessmentHistoryRecords = () => {
  return [
    {
      title: 'Sent Date',
      dataIndex: 'sentDate',
      render: (_, record) => dayjs(record.sentDate).format('MM/DD/YY'),
    },
    {
      title: 'Report Date',
      dataIndex: 'reportDate',
    },
    {
      title: 'Assessment',
      dataIndex: 'assessmentName',
    },
    {
      title: 'Percent Complete',
      dataIndex: 'percentComplete',
      render: (_, record) => `${record.percentComplete}%`,
    },
    {
      title: 'Actions',
      dataIndex: 'reportUrl',
      render: (_, record) =>
        record.reportUrl && (
          <a href={record.reportUrl} target="_blank" rel="noreferrer">
            View Report
          </a>
        ),
      width: '114px',
    },
  ] as ColumnsType<IAssessmentHistory>;
};
